export enum TransferEvent {
    Initiated = "Transfer_Initiated",
    BalanceSave = "Transfer_BalanceSave",
    Result = "Transfer_Result",
    TransactionExpired = "Transfer_Expired",
    RestoredTransfer = "Transfer_RestoredTransfer"
}